import { Fragment, VFC } from 'react';
import { FormItemProps } from 'components/Form/FormItem';
import { ElectricityMeterDetailField } from './constants';
import { AdditionalElectricityDetails, getElectricityDetailFormItem } from './utils/getDetailFormItem';

interface ElectricityDetailsProps {
  itemsConfig: Partial<
    Record<
      ElectricityMeterDetailField,
      {
        formItemProps?: FormItemProps;
        additionalConfig?: AdditionalElectricityDetails;
      }
    >
  >;
}

export const ElectricityDetails: VFC<ElectricityDetailsProps> = ({ itemsConfig }) => (
  <>
    {Object.entries(itemsConfig).map(([item, { additionalConfig = {}, formItemProps = {} }]) => (
      <Fragment key={item}>
        {getElectricityDetailFormItem(item as ElectricityMeterDetailField, formItemProps, additionalConfig)}
      </Fragment>
    ))}
  </>
);
